module.exports = __webpack_public_path__ + "img/only1-generation.2bfc98bf.png";